import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as pageAction from './../../../../../actions/pageAction';
import PageDetail from './PageDetail';

const mapStateToProps = state => {
    return {
        pageState: state.pageReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPageDetail: (id) => dispatch(pageAction.getPageDetail(id)),
        setPageDetail: (page) => dispatch(pageAction.setPageDetail(page)),
        updatePageDetail: (page) => dispatch(pageAction.updatePageDetail(page)),
        createPageDetail: (page) => dispatch(pageAction.createPageDetail(page)),
        createPageTranslate: (page, language) => dispatch(pageAction.createPageTranslate(page, language)),
        updatePageTranslate: (page, language) => dispatch(pageAction.updatePageTranslate(page, language)),
        deletePageTranslate: (page, refreshParams) => dispatch(pageAction.deletePageTranslate(page, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PageDetail));
